import UIFlex from 'UIComponents/layout/UIFlex';
import LearningPageSidebar from '../../../containers/TrackPage/LearningPageSidebar';
import UIBox from 'UIComponents/layout/UIBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BOTTOM_SPACING = 40;
export const LearningContentPageLayout = ({
  header,
  navigation,
  children
}) => {
  return /*#__PURE__*/_jsxs("article", {
    style: {
      paddingBottom: navigation ? 0 : BOTTOM_SPACING
    },
    children: [header, navigation ? /*#__PURE__*/_jsxs(UIFlex, {
      children: [/*#__PURE__*/_jsx(LearningPageSidebar, {
        id: "sidebarNavigator",
        withSubNav: 1,
        children: navigation
      }), /*#__PURE__*/_jsx(UIBox, {
        grow: 1,
        style: {
          paddingBottom: BOTTOM_SPACING
        },
        children: children
      })]
    }) : children]
  });
};
export default LearningContentPageLayout;